export default "/content/plugin-channel-alarms/5e2ef174966cd8efb11bfc434af167e3.wav";